export type PlanLevel = 1 | 2

export const isValidPlanLevel = (level: number): level is PlanLevel =>
  level === 1 || level === 2

export type TierConstant = {
  name: string
  href: string
}

export const STARTER_TIER: TierConstant = {
  name: 'Starter',
  href: '/perks',
}

export const ALL_ACCESS_TIER: TierConstant = {
  name: 'All Access',
  href: '/perks',
}

/**
 * Valid paid tier names for the 2-tier system
 */
export const VALID_PAID_TIERS = [STARTER_TIER.name, ALL_ACCESS_TIER.name]

export const mapTierToName = (contentTier: string | number): TierConstant => {
  const tier = contentTier.toString()
  if (tier === '2') {
    return { name: ALL_ACCESS_TIER.name, href: ALL_ACCESS_TIER.href }
  }

  return { name: STARTER_TIER.name, href: STARTER_TIER.href }
}

export const mapNameToTier = (name: string): string => {
  if (name === ALL_ACCESS_TIER.name) {
    return '2'
  }

  return '1'
}
